import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import CommonAPI from '../../../Shared/CommonAPI';

import Block from '../../../Controls/Scafolding/Block';

import { Row, Col, Container, FormGroup, Input, Button } from 'reactstrap';

import { ContentAbout0, ContentAbout1, ContentAbout2, ContentAbout3, ContentAbout4, ContentRegister0, ContentRegister1, ContentRegister2, ContentRegister3 } from './_ContentBlocks';
import { TextBock, TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';
import Marker from '../../../Controls/Digital/Marker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faEnvelopeOpen, faMobile } from '@fortawesome/free-solid-svg-icons';

import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text, icon }) => <div> <div class="google-maps-marker"> </div> <span className="google-maps-marker-text">{text}</span></div>;

const ContactUs = (props) =>{

    const [blockName, setBlockName] = useState("");
    const [model, setModel] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    const handleChange = e => {
        setModel({ ...model, [e.target.name]: e.target.value });
        Common.log("Changed Field {0} to {1}", [e.target.name, e.target.value]);
    }

    const sendMessage = () => {
        Common.trace("send message");
        Common.log(model);

        CommonAPI.sendMessage(
            model,
            null,
            {
                successMessage: "Thanks for your message; we will be in touch soon!!!",
                errorMessage: "An error Ocurred; please use the provided email or phone number to reach us"
            });
    }

    const defaultProps = {
        center: {
            lat: -34.41612574283569,
            lng: 150.88449539804378
        },
        zoom: 18
    };

    return (
        <Block name="contactUs" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Contact Us
                </Fragment>
            } />

            <TextBock text={
                <Fragment>
                    For any enquiry regarding Caterings, openning times or our produce just reach out!!!
                </Fragment>
            } />

            <TextTitle text={
                <Fragment>
                        <a className="contact-email" href="mailto:info@GwynnevilleBakery.com.au">info@GwynnevilleBakery.com.au</a><br/>
                        02 4227 2652
                </Fragment>
            } />
            
            <TextBock text={
                <Fragment>
                    <b>168 Gipps Rd</b><br/>
                    <b>Gwynneville NSW 2500</b><br />
                    Mon - Fri: 9am - 5pm<br />
                    Sat : 10am - 16pm <br />
                    Sun : CLOSED
                </Fragment>
            } />

            <Row>

                <Col lg={{ size: 8, offset: 2 }}>
                    <div style={{ height: '50vh', width: '100%' }}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyC0lxhbs8od46o2NjWQCcXVSWq5C_0yXJI" }}
                            defaultCenter={defaultProps.center}
                            defaultZoom={defaultProps.zoom}
                            yesIWantToUseGoogleMapApiInternals
                        >
                            <AnyReactComponent
                                lat={-34.41612574283569}
                                lng={150.88449539804378}
                                text="Bakery"
                            />

                        </GoogleMapReact>
                    </div>
                </Col>

            </Row>

        </Block>
    );
}
export default ContactUs;
